module.exports = __webpack_public_path__ + "static/media/bez_temp_w_domu_czuwanie.764a9124.svg";